// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

export const INVOICE_BANK_ACCOUNT_NAME = 'Osuuspankki';
export const INVOICE_BANK_ACCOUNT_IBAN = 'FI78 5741 4020 1410 94';
export const INVOICE_BANK_ACCOUNT_BIC = 'OKOYFIHH';
